import React from 'react';
import { PublicSection, Reveal } from '@/components/public';
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from '@/components/ui/accordion';
import { INTEGRATIONS_FAQ } from '@/config/integrations';

export default function IntegrationsFaq() {
  return (
    <PublicSection
      id="integrations-faq"
      testId="integrations-faq-section"
      variant="alt"
      eyebrow="Questions & Answers"
      title="Integration FAQs"
      description="The questions Canadian restaurant owners ask most before connecting their POS, payments, and printers."
      padTop="pt-16 md:pt-20"
      padBottom="pb-16 md:pb-20"
    >
      <Reveal>
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="w-full border-t border-border">
            {INTEGRATIONS_FAQ.map((item) => (
              <AccordionItem
                key={item.id}
                value={item.id}
                className="border-b border-border"
                data-testid={`integrations-faq-item-${item.id}`}
              >
                <AccordionTrigger
                  className="py-5 text-base md:text-lg font-heading font-bold tracking-tight text-foreground hover:no-underline data-[state=open]:text-primary text-left"
                  data-testid={`integrations-faq-trigger-${item.id}`}
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent
                  className="pb-5 text-sm md:text-base text-muted-foreground leading-relaxed"
                  data-testid={`integrations-faq-answer-${item.id}`}
                >
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </Reveal>
    </PublicSection>
  );
}
